import React from "react";
import {
  AppBar,
  Avatar,
  Box,
  Chip,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import SearchDD from "./SearchDD";
import ProfileDD from "./ProfileDD";
import LogoIcon from "../../logo/LogoIcon";
import { useAuthProvider } from "../../../context/AuthProvider";
import Link from "next/link";

const Header = ({ sx, customClass, toggleMobileSidebar, position }) => {
  const { user } = useAuthProvider();
  console.log(user);

  return (
    <AppBar sx={sx} position={position} elevation={0} className={customClass}>
      <Toolbar>
        <Box
          sx={{
            display: {
              md: "flex",
              xs: "none",
            },
          }}
        >
          <Link href={"/overview"}>
            <img
              src="/iDonatio.png"
              style={{ marginRight: "1em", height: "2em", cursor: "pointer" }}
            />
          </Link>

          <Box width={"1px"} sx={{ background: "#C4CBD4", marginRight: "1em" }}>
            {user?.type == "individual" ? (
              <Avatar
                sx={{ marginLeft: "1em", height: "50px", width: "50px" }}
                src={user?.profile_image}
              />
            ) : (
              <Avatar
                sx={{ marginLeft: "1em", height: "50px", width: "50px" }}
                src={user?.image_url}
              />
            )}
          </Box>
          <Typography
            variant="big"
            component={"p"}
            marginLeft="4.5em"
            display="flex"
            flexDirection="column"
            alignItems={"flex-start"}
            rowGap={"4px"}
            justifyContent={"center"}
          >
            {user?.preferred_name
              ? user?.preferred_name
              : user?.type == "individual"
                ? `${user.first_name} ${user.last_name}`
                : user?.type == "organization"
                  ? `${user?.organization?.name}`
                  : null}
            {user && !user?.charity_is_verified ? (
              <Chip
                label={
                  user && !user?.charity_is_verified
                    ? "Charity verification failed"
                    : null
                }
                size="small"
                sx={{
                  bgcolor: "#FFEECC",
                  color: "#B27800",
                  fontWeight: "600",
                  borderRadius: "4px",
                  fontSize: "10px",
                  height: "16px",
                }}
              />
            ) : null}
          </Typography>
        </Box>

        <IconButton
          size="large"
          color="inherit"
          aria-label="menu"
          onClick={toggleMobileSidebar}
          sx={{
            display: {
              md: "none",
              xs: "flex",
            },
          }}
        >
          <i class="las la-bars la-sm" style={{ color: "blue" }}></i>
        </IconButton>
        {/* ------------------------------------------- */}
        {/* Search Dropdown */}
        {/* ------------------------------------------- */}
        {/* <SearchDD /> */}
        {/* ------------ End Menu icon ------------- */}

        <Box flexGrow={1} />
        <Box>
          <ProfileDD />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
  customClass: PropTypes.string,
  position: PropTypes.string,
  toggleSidebar: PropTypes.func,
  toggleMobileSidebar: PropTypes.func,
};

export default Header;
